import { ANALISE_COMPARATIVA } from '@/features/landing/conteudo';

/**
 * Tela cheia própria, logo após Recursos. Mesmo padrão visual das outras telas
 * (selo + headline + parágrafo em `max-w-2xl`, card com chip de ícone em
 * gradiente) — mas com um recurso só: aqui a leitura sai do paciente
 * individual e vai para o conjunto da rotina, e a página ainda não tem mockup
 * dessa tela para justificar uma grade.
 */
export function SecaoAnaliseComparativa() {
  const { card } = ANALISE_COMPARATIVA;

  return (
    <section
      id="analise-comparativa"
      className="scroll-mt-20 border-b border-border bg-background py-20"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-wider text-accent">
            {ANALISE_COMPARATIVA.selo}
          </p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            {ANALISE_COMPARATIVA.titulo}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted-foreground">
            {ANALISE_COMPARATIVA.paragrafo}
          </p>
        </div>

        <div className="mt-10 max-w-xl rounded-xl border border-border bg-card p-6">
          <div className="w-fit rounded-lg bg-gradient-nohra p-2.5 shadow-sm">
            <card.icone className="h-5 w-5 text-white" />
          </div>
          <h3 className="mt-4 font-semibold text-card-foreground">{card.titulo}</h3>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{card.descricao}</p>
        </div>
      </div>
    </section>
  );
}
